export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5500.165e3b61.jpg";